import { contentTypeIds, ContentTypeId, PageKind } from "./types";

export const pageKindToNotificationEntry: Record<PageKind, ContentTypeId[]> = {
  community: [
    contentTypeIds.communityVideoEntry,
    contentTypeIds.communityLivestreamEntry,
  ],
  esport: [contentTypeIds.esportNewsEntry, contentTypeIds.esportCarouselEntry],
  news: [contentTypeIds.newsEntry, contentTypeIds.carouselEvent],

  blog: [],
};

export const notificationEntryToPageKind: Record<ContentTypeId, PageKind> =
  Object.entries(pageKindToNotificationEntry).reduce(
    (acc, value) => {
      const [pageKind, contentTypeIds] = value;

      for (const id of contentTypeIds) {
        acc[id] = pageKind as PageKind;
      }

      return acc;
    },

    {} as Record<ContentTypeId, PageKind>,
  );

export const entriesWithNotifications = Object.values(
  pageKindToNotificationEntry,
).flat();
